import { RESET_STUDIO_ACTION } from '../reducers/consts';
import { dispatchAnalyticsEvent } from '../modules/global.utils';
import { getContainerStatus, CONTAINER_STATUS } from '../modules/project.utils';
import { isWindowVisible } from '../modules/studio/utils';

let loadStartDate: $TSFixMe;
let reported: $TSFixMe;

const studioLoadMiddleware = (store: $TSFixMe) => (next: $TSFixMe) => (action: $TSFixMe) => {
    switch (action?.type) {
        case 'INIT_STUDIO':
            loadStartDate = new Date();
            break;

        case RESET_STUDIO_ACTION:
            loadStartDate = null;
            reported = false;
            break;

        case 'FETCH_PROJECT_SUCCEEDED': {
            const prevContainerStatus = getContainerStatus(store.getState().studio.project);
            const nextValue = next(action);
            const containerStatus = getContainerStatus(store.getState().studio.project);
            if (prevContainerStatus === CONTAINER_STATUS.STARTING && containerStatus === CONTAINER_STATUS.RUNNING) {
                loadStartDate = new Date(); // if container was hibernating
                reported = false;
            }
            return nextValue;
        }

        case 'FRAME_SET_APP_LOADED':
        case 'FETCH_FIELDS_SUCCEED':
        case 'FETCH_PAGE_MODELS_SUCCEEDED': {
            if (reported) {
                break;
            }
            const nextValue = next(action);
            const state = store.getState();
            if (state.studio.fields && state.studio.schema && state.studio.frame.isAppLoaded) {
                const loadTime = Date.now() - loadStartDate.getTime();
                dispatchAnalyticsEvent('Studio Load Interactive', {
                    loadTime,
                    state: isWindowVisible() ? 'foreground' : 'background'
                });
                reported = true;
            }
            return nextValue;
        }
    }

    return next(action);
};

export default studioLoadMiddleware;
